module.exports = __webpack_public_path__ + "image/news-banner.jpg";